module.exports = __webpack_public_path__ + "static/media/favorite-24px.ef2f8e67.svg";